import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link = 'https://fh.filgolf.com/files/ele/B_Notice_of_Annual_Meeting.pdf';

export default function B() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>B. Notice of Annual Meeting</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
